import { css, html, LitElement } from 'lit'
import { property } from 'lit/decorators.js'
import { safeCustomElement } from '@/utilities/custom-element'
import type { DividerStyle } from './types'

@safeCustomElement('mdc-divider')
export class MdcDivider extends LitElement {
  @property({ type: String, reflect: true }) orientation: DividerStyle = 'vertical'

  static styles = css`
		:host {
			display: block;
			width: 100%;
			--mdc-divider-color: var(--color-functional-gray-200, #e5e5e5);
			font-family: var(--typography-font-family-sans);
		}

		:host([orientation="vertical"]) {
			height: 100%;
			width: 1px;
			display: block;
			flex-shrink: 0;
			background: var(--mdc-divider-color);
		}

		.mdc-divider-new--style-horizontal {
			width: 100%;
			height: 1px;
			background: var(--mdc-divider-color);
			border: none;
			margin: 0;
			padding: 0;
			display: block;
		}

		.mdc-divider-new--style-vertical {
			width: 100%;
			height: 100%;
			background: var(--mdc-divider-color);
			display: block;
		}
	`

  render() {
    const orientation = this.orientation === 'vertical' ? 'vertical' : 'horizontal'
    const className = `mdc-divider-new mdc-divider-new--style-${orientation}`

    if (orientation === 'horizontal') {
      return html`<hr class=${className} />`
    }

    return html`<div class=${className} aria-hidden="true"></div>`
  }
}
